import type {
  DeliveryRoute,
  DeliveryRoutePagedList,
  DeliveryRoutePagedListResponse,
  CreateDeliveryRouteRequest,
  DeliveryRouteResponse,
  DeliveryRoutesListParams,
  BooleanResponse,
  UpdateDeliveryRouteRequest,
} from '@apiContract';

import { receivedDigitalApi } from './index';

const deliveryRoutesApi = receivedDigitalApi.injectEndpoints({
  endpoints: (builder) => ({
    getDeliveryRouteById: builder.query<DeliveryRoute, string | number | undefined>({
      query: (id) => `DeliveryRoutes/${id}`,
      providesTags: ['DeliveryRoutes'],
      transformResponse: (response: DeliveryRouteResponse) => response.objectData,
    }),
    getDeliveryRoutesList: builder.query<DeliveryRoutePagedList, DeliveryRoutesListParams>({
      query: (params) => ({
        url: 'DeliveryRoutes',
        params,
      }),
      providesTags: ['DeliveryRoutes'],
      transformResponse: (response: DeliveryRoutePagedListResponse) => response.objectData,
    }),
    createDeliveryRoute: builder.mutation<DeliveryRoute, CreateDeliveryRouteRequest>({
      query: (requestData) => ({
        url: 'DeliveryRoutes',
        method: 'POST',
        body: requestData,
      }),
      invalidatesTags: ['DeliveryRoutes'],
      transformResponse: (response: DeliveryRouteResponse) => response.objectData,
    }),
    updateDeliveryRoute: builder.mutation<DeliveryRoute, UpdateDeliveryRouteRequest>({
      query: (requestData) => ({
        url: 'DeliveryRoutes',
        method: 'PUT',
        body: requestData,
      }),
      invalidatesTags: ['DeliveryRoutes'],
      transformResponse: (response: DeliveryRouteResponse) => response.objectData,
    }),
    deleteDeliveryRoute: builder.mutation<DeliveryRoute, number>({
      query: (id) => ({
        url: `DeliveryRoutes?id=${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['DeliveryRoutes'],
      transformResponse: (response: DeliveryRouteResponse) => response.objectData,
    }),
    bulkDeleteDeliveryRoute: builder.mutation<boolean, number[]>({
      query: (requestData) => ({
        url: `DeliveryRoutes/list`,
        method: 'DELETE',
        body: requestData,
      }),
      invalidatesTags: ['DeliveryRoutes'],
      transformResponse: (response: BooleanResponse) => response.objectData,
    }),
  }),
});

export const {
  useGetDeliveryRouteByIdQuery,
  useGetDeliveryRoutesListQuery,
  useCreateDeliveryRouteMutation,
  useUpdateDeliveryRouteMutation,
  useDeleteDeliveryRouteMutation,
  useBulkDeleteDeliveryRouteMutation,
} = deliveryRoutesApi;
